<template>
  <div class="ma-0 pa-0 workflow-info-node-root">
    <div>
      <v-card
        class="pa-3 text-center workflow-info-node-card"
        :class="{
          'workflow-info-node-card--end': node.data.type === 'end',
          'workflow-info-node-card--delete': node.data.type === 'delete',
          'workflow-info-node-card--branch': isIfBranch,
        }"
        :color="(this.node.data.type == 'delete') ? 'white' : 'background'"
        :style="{ opacity: ((this.node.hidden) ? 0 : 1) }"
        :width="infoCardWidth"
        :disabled="(this.node.data.type == 'delete')"
        :height="infoCardHeight"
        :elevation="(this.node.data.type == 'delete') ? 1 : 0"
      >
        <v-card-text
          class="pa-0"
          :class="{
            'workflow-info-node-card-text--delete': node.data.type === 'delete',
            'workflow-info-node-card-text--branch': isIfBranch,
          }"
        >
          <v-icon
            v-if="this.node.data.type == 'end'"
            class="mb-2"
          >mdi-flag-checkered</v-icon>
          <div
            v-if="displayDescription"
            class="workflow-info-node-description"
            v-html="displayDescription"
          ></div>
          <v-tooltip
            v-if="this.node.data.type == 'end'"
            location="top"
          >
            <template #activator="{ props: tooltipProps }">
              <v-btn
                v-bind="tooltipProps"
                elevation="1"
                icon
                size="x-small"
                rounded="circle"
                class="mt-3 nodrag nopan workflow-info-add-btn"
                @click.stop="newNode"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add Action</span>
          </v-tooltip>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowActionInfoNode',

  props: {
    remove: {
      type: Function,
      required: true,
    },
    node: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
  },

  computed: {
    isIfBranch() {
      const type = this.node && this.node.data && this.node.data.type;
      return type === 'if_true' || type === 'if_false';
    },
    displayDescription() {
      if (this.description) return this.description;
      if (this.node && this.node.data && this.node.data.description) {
        return this.node.data.description;
      }
      if (this.node && this.node.data && this.node.data.type === 'end') {
        return 'Finish';
      }
      return this.title || '';
    },
    infoCardHeight() {
      if (this.node.data.type === 'delete') return 100;
      // End: auto height so flag + "Finish" + add button are all visible (V3
      // v-card overflow clips master's fixed 75px + mb-7/mt-7 overflow trick).
      if (this.node.data.type === 'end') return undefined;
      // if_true / if_false: tighter than master's 75 so label padding is even.
      if (this.isIfBranch) return 48;
      return 75;
    },
    // Match action width (300) so center-to-center edges stay straight.
    infoCardWidth() {
      if (this.node.data.type === 'delete') return 275;
      return 300;
    },
  },

  methods: {
    newNode () {
      if (typeof this.node.requestAddChild === 'function') {
        this.node.requestAddChild();
        return;
      }
      // Legacy Flowy fallback
      this.node.addNew = true;
      this.remove();
    },
  },
};
</script>

<style scoped>
.workflow-info-node-root {
  position: relative;
}
/* Master V2 card default was 4px; global VCard default is sm (2px). */
.workflow-info-node-card {
  border-radius: 4px !important;
}
.workflow-info-node-card--end {
  overflow: visible !important;
  height: auto !important;
  min-height: 75px;
}
.workflow-info-node-card--delete {
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.workflow-info-node-card--branch {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.workflow-info-node-card-text--delete,
.workflow-info-node-card-text--branch {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
}
.workflow-info-node-description {
  line-height: 1.4;
}
.workflow-info-add-btn {
  position: relative;
  z-index: 6;
  pointer-events: all !important;
}
</style>
